import React, { useState } from 'react';
import { toast } from 'sonner';
import { GlassCard } from './GlassCard';
import { useUserStore } from '../store/userStore';
import { updateWellbeingStatement } from '../lib/api';

const MAX = 1000;

export function WellbeingStatementCard() {
  const { user, setUser } = useUserStore();
  const [text, setText] = useState(user?.wellbeing_statement || '');
  const [saving, setSaving] = useState(false);
  const dirty = text !== (user?.wellbeing_statement || '');

  const save = async () => {
    setSaving(true);
    try {
      const res = await updateWellbeingStatement(user.id, text);
      setUser({ ...user, wellbeing_statement: res.wellbeing_statement });
      toast.success('Saved — your clinician can now see this');
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Could not save');
    } finally {
      setSaving(false);
    }
  };

  return (
    <GlassCard className="p-6 mb-5 animate-fade-up" data-testid="wellbeing-statement-card">
      <div className="flex items-start gap-3 mb-3">
        <div className="grid place-items-center w-10 h-10 rounded-xl bg-[var(--aura-pink)]/12 text-[var(--aura-pink)] shrink-0"><i className="fa-solid fa-comment-heart" /></div>
        <div>
          <h3 className="font-display text-xl">How I generally feel</h3>
          <p className="text-sm text-[var(--aura-ink-soft)]">In your own words — your clinician reads this before your review, so say what matters to you.</p>
        </div>
      </div>
      <textarea
        data-testid="wellbeing-statement-input"
        value={text}
        onChange={(e) => setText(e.target.value.slice(0, MAX))}
        maxLength={MAX}
        rows={5}
        placeholder="e.g. Most days I feel wiped out by mid-afternoon, I'm not sleeping through, and the brain fog is making work stressful…"
        className="w-full rounded-xl border border-[var(--aura-line)] px-4 py-3 outline-none focus:border-[var(--aura-purple)] resize-none text-sm"
      />
      <div className="flex items-center justify-between mt-2">
        <span data-testid="wellbeing-statement-count" className={`text-xs ${text.length >= MAX ? 'text-red-600 font-semibold' : 'text-[var(--aura-ink-soft)]'}`}>{text.length}/{MAX}</span>
        <button
          data-testid="wellbeing-statement-save"
          onClick={save}
          disabled={saving || !dirty}
          className="aura-btn-gradient text-white font-semibold rounded-xl px-4 py-2 text-sm flex items-center gap-2 disabled:opacity-50"
        >
          {saving ? <i className="fa-solid fa-circle-notch fa-spin" /> : <i className="fa-solid fa-floppy-disk" />} Save
        </button>
      </div>
    </GlassCard>
  );
}
